<template>
  <div>
    <van-sticky>
      <!-- 导航栏 -->
      <van-nav-bar>
        <template #left>
          <!-- 当前用户 -->
          <van-dropdown-menu class="menu">
            <van-dropdown-item
              v-model="selectUser"
              :options="allUser"
              :disabled="$store.getters.point_admin_power === '2' ? false :true"
              @change="changeUser"
            />
          </van-dropdown-menu>
        </template>
        <template #right>
          <van-button v-if="$store.getters.point_admin_power === '2'" type="info" size="mini" class="custombtn">调  整</van-button>
          <van-button type="info" size="mini" @click="toApplyPoint()">申  请</van-button>
          <font class="applyfont">可用积分：{{ integralSum }}</font>
        </template>
      </van-nav-bar>
      <!-- 本月 积分记录 筛选栏 -->
      <van-dropdown-menu>
        <van-dropdown-item v-model="opt_value" :options="opt_dates" :title="picker.title_date" @change="ChangeSelectDate" />
        <van-dropdown-item v-model="setrecord" :options="record" @change="Changesetrecord" />
      </van-dropdown-menu>
      <!-- van-datetime-picker 日期选择框-->
      <van-popup v-model="picker.showDatePicker" position="bottom">
        <van-datetime-picker
          v-model="picker.currentDate"
          type="year-month"
          :min-date="picker.minDate"
          :max-date="picker.maxDate"
          @confirm="ConfirmDatePicker"
          @cancel="CancelDatePicker"
        />
      </van-popup>
    </van-sticky>
    <!-- table数据列表 -->
    <applytabledata ref="Function" @getPointSum="getPointSum" />
  </div>
</template>
<script>
import { GetPointSum, GetAllUser } from '@/api/EducationalPoints'
import applytabledata from './ApplyTableData'
const moment = require('moment')
export default {
  name: 'EducationalPoints',
  components: { applytabledata },
  data() {
    return {
      selectUser: this.$store.getters.usercode,
      allUser: [],
      opt_value: 0,
      opt_dates: [
        { text: '本月', value: 0, icon: 'clock-o' },
        { text: '前月', value: 1, icon: 'clock-o' },
        { text: '全年', value: 2, icon: 'clock-o' },
        { text: '自定义', value: 3, icon: 'aim' }
      ],
      Point_data_s: moment().startOf('month').format('YYYY-MM-DD'),
      Point_data_e: moment().endOf('month').format('YYYY-MM-DD'),
      setrecord: 0,
      record: [
        { text: '积分记录', value: 0 },
        { text: '申请记录', value: 1 }
      ],
      container: null,
      integralSum: 0,
      picker: {
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(moment().add(1, 'year').endOf('month')),
        currentDate: new Date(),
        showDatePicker: false,
        title_date: '本月'
      }
    }
  },
  created() {
    // 获取当前可用积分数
    this.getPointSum(this.$store.getters.usercode)
    // 获取全部在职人员
    this.getAllUser()
  },
  mounted() {
    // 获取积分记录数据
    this.$refs.Function.getPointInfo()
  },
  methods: {
    // 日期变更
    ChangeSelectDate(value) {
      switch (value) {
        // 本月
        case 0:
          var thisMonth = moment().format('YYYY-MM')
          this.picker.title_date = this.opt_dates[value].text
          this.opt_value = this.opt_dates[value].value
          this.Point_data_s = moment(thisMonth).startOf('month').format('YYYY-MM-DD')
          this.Point_data_e = moment(thisMonth).endOf('month').format('YYYY-MM-DD')
          // 积分记录
          if (this.setrecord === 0) {
            this.$refs.Function.getPointInfo()
          // 申请记录
          } else {
            this.$refs.Function.getPointApplyInfo()
          }
          break
        // 前月
        case 1:
          var lastMonth = moment().subtract(1, 'months').format('YYYY-MM')
          this.picker.title_date = this.opt_dates[value].text
          this.opt_value = this.opt_dates[value].value
          this.Point_data_s = moment(lastMonth).startOf('month').format('YYYY-MM-DD')
          this.Point_data_e = moment(lastMonth).endOf('month').format('YYYY-MM-DD')
          // 积分记录
          if (this.setrecord === 0) {
            this.$refs.Function.getPointInfo()
          // 申请记录
          } else {
            this.$refs.Function.getPointApplyInfo()
          }
          break
        // 全年
        case 2:
          this.picker.title_date = this.opt_dates[value].text
          this.opt_value = this.opt_dates[value].value
          this.Point_data_s = moment().startOf('year').format('YYYY-MM-DD')
          this.Point_data_e = moment().endOf('year').format('YYYY-MM-DD')
          // 积分记录
          if (this.setrecord === 0) {
            this.$refs.Function.getPointInfo()
          // 申请记录
          } else {
            this.$refs.Function.getPointApplyInfo()
          }
          break
        default:
          this.picker.showDatePicker = true
          this.opt_value = ''
          break
      }
    },
    // van-datetime-picker 确认日期选择框
    ConfirmDatePicker(value) {
      this.picker.showDatePicker = false
      // 自定义日期等于当月
      if (moment(value).format('YYYY/MM') === moment().format('YYYY/MM')) {
        this.picker.title_date = this.opt_dates[0].text
        this.opt_value = this.opt_dates[0].value
        this.Point_data_s = moment().startOf('month').format('YYYY-MM-DD')
        this.Point_data_e = moment().endOf('month').format('YYYY-MM-DD')
      // 自定义日期等于前月
      } else if (moment(value).format('YYYY/MM') === moment().add(-1, 'month').format('YYYY/MM')) {
        this.picker.title_date = this.opt_dates[1].text
        this.opt_value = this.opt_dates[1].value
        this.Point_data_s = moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD')
        this.Point_data_e = moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
      } else {
        this.picker.title_date = moment(value).format('YYYY/MM')
        this.opt_value = ''
        this.Point_data_s = moment(value).startOf('month').format('YYYY-MM-DD')
        this.Point_data_e = moment(value).endOf('month').format('YYYY-MM-DD')
      }
      // 积分记录
      if (this.setrecord === 0) {
        this.$refs.Function.getPointInfo()
        // 申请记录
      } else {
        this.$refs.Function.getPointApplyInfo()
      }
    },
    // van-datetime-picker 关闭日期选择框
    CancelDatePicker() {
      this.picker.showDatePicker = false
    },
    // 获取当前可用积分数
    getPointSum(user_id) {
      const that = this
      GetPointSum({ user_id: user_id }, function(res) {
        if (res.code === 0) {
          that.integralSum = JSON.parse(res.data)[0].result
        } else {
          that.integralSum = 0
        }
      })
    },
    // 获取全部在职人员
    getAllUser() {
      const that = this
      GetAllUser(function(res) {
        if (res.code === 0) {
          const value = JSON.parse(JSON.parse(res.data))
          var newArr = value.map(item => ({
            text: item.user_name + '(' + item.user_code + ')',
            value: item.user_code
          }))
          that.allUser = newArr
        } else {
          that.allUser = []
        }
      })
    },
    // 人员切换
    changeUser(val) {
      // 获取当前可用积分数
      this.getPointSum(val)
    },
    // 跳转教育积分申请画面
    toApplyPoint() {
      this.$router.push(
        { path: '/EducationalPointsApply' }
      )
    },
    // 积分记录 筛选栏
    Changesetrecord(val) {
      // 积分记录
      if (val === 0) {
        // 获取积分记录数据
        this.$refs.Function.getPointInfo()
      // 申请记录
      } else {
        // 获取申请记录数据
        this.$refs.Function.getPointApplyInfo()
      }
    }
  }
}
</script>
<style scoped>
  .container{
    background-color: #F5F5F5;
  }
  .van-nav-bar{
    height: 50px;
  }
  .magin-position{
    margin-left: -13px;
    margin-top: 3px;
  }
  .applyfont{
    margin-left: 10px;
    font-size: 11pt;
  }
  .custombtn{
    background-color:#46CDCF;
    border: #46CDCF;
  }
  .menu >>> .van-dropdown-menu__bar{
    width:117%
  }
  /deep/.van-nav-bar__left{
    padding:0px;
  }
  /deep/.van-nav-bar__right{
    padding:0px 10px 0px 0px;
  }
  /deep/.van-button{
    vertical-align:middle;
  }
</style>
